import { SelectionRepository } from 'src/projects/SelectionRepository.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { WorkBook } from 'src/projects/hooks/composeExcelBuffer.ts';
import { isLink } from 'src/common/types/isLink.ts';
import { isArrayOfUnitValue } from 'src/common/types/IsUnitValue.ts';
import { numberFormatter } from 'src/utils/numberFormatter.ts';
import { isArrayOfLocaleValuesFragment } from 'src/common/types/isArrayOfLocaleValuesFragment.ts';
import { Link } from 'src/common/types/Link.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { isLocaleValuesFragment } from 'src/common/types/isLocaleValuesFragment.ts';
import { decodeHtml } from 'src/utils/decodeHtml.ts';

export const exportAllPrepare = async ({
    selectionRepository,
    userSettings,
    t,
}: {
    selectionRepository: SelectionRepository;
    userSettings: UserSettings;
    t: BelimoTranslate;
}) => selectionRepository.list(selectionRepository.count(), 0)
    .reduce((acc, selection) => {
        acc[selection.type].columns = selection.exportData.columns.map((v) => {
            const column = t(v).trim();
            return {
                header: column,
                key: column,
                width: 15,
            };
        });
        selection.exportData.rows.forEach((cells) => {
            const mapped = cells.map((cell) => {
                if (cell === null || cell === undefined) {
                    return '';
                }
                if (isLink(cell)) {
                    return cell;
                }
                let value: string | Link = `${cell}`.trim();
                if (isArrayOfLocaleValuesFragment(cell)) {
                    value = cell.map((v) => t(v, false).trim()).join(', ');
                } else if (isArrayOfUnitValue(cell)) {
                    value = cell.map((r) => {
                        const [v, u] = r;
                        return `${numberFormatter(v, userSettings.currentLocale)} ${t(u, false)}`;
                    }).join(', ');
                } if (isLocaleValuesFragment(cell)) {
                    value = t(cell, false);
                }
                return decodeHtml(value);
            });
            acc[selection.type].rows.push(mapped);
        });
        return acc;
    }, {
        actuators: { columns: [], rows: [], name: t(MESSAGES.Actuators) },
        sensors: { columns: [], rows: [], name: t(MESSAGES.Sensors) },
        valves: { columns: [], rows: [], name: t(MESSAGES.Valves) },
    } as WorkBook);
